import { getDate, getMonth, getYear } from 'date-fns'
import { api } from '~/services/api'

export async function calculaAnuidadeProporcional(mensalidadeValor) {
    const mesAtual = getMonth(new Date())
    const diaAtual = getDate(new Date())
    const valor = mensalidadeValor
    let competenciaAno = new Date().getFullYear()
    let valorAnuidadeProporcional

    if (mesAtual === 11 && diaAtual > 28) {
        const response = await api.get(`mensalidade_valor/${new Date().getFullYear() + 1}`)

        if (response) {
            valorAnuidadeProporcional = Number(response.valor) * 12
            competenciaAno = new Date().getFullYear() + 1

            if (getYear(new Date()) === 2026) {
                valorAnuidadeProporcional += 0.10
            }
        } else {
            valorAnuidadeProporcional = valor

            if (getYear(new Date()) === 2026) {
                valorAnuidadeProporcional += 0.10
            }
        }
    } else if (diaAtual > 28) {
        valorAnuidadeProporcional = mensalidadeValor * (12 - (mesAtual + 1))
    } else {
        valorAnuidadeProporcional = mensalidadeValor * (12 - mesAtual)
    }

    if (Number(valorAnuidadeProporcional.toFixed(2)) === 834.18) {
        valorAnuidadeProporcional += 0.05
    }
    console.log(valorAnuidadeProporcional)
    return { valorAnuidadeProporcional, competenciaAno }
}
